import type { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { v } from '@/theme/tokens';

interface AuthLayoutProps {
  /** Heading above the form. Omitted when used as a route layout. */
  title?: string;
  /** The form itself. Falls back to the router outlet when absent. */
  children?: ReactNode;
}

export function AuthLayout({ title, children }: AuthLayoutProps) {
  return (
    <div
      className="rt-auth"
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        background: v('bg'),
      }}
    >
      {/* The same soft brand light as the app shell, so the sign-in card is
          glass over something. Hidden in the classic skin. */}
      <div className="rt-backdrop" aria-hidden />
      <main
        className="rt-auth-card"
        style={{
          width: '100%',
          maxWidth: 380,
          padding: 28,
        }}
      >
        <div style={{ marginBottom: 22 }}>
          <div style={{ fontSize: 18, fontWeight: 700, letterSpacing: '-0.01em' }}>Ramen Ten</div>
          <div style={{ fontSize: 12.5, color: v('ink-muted'), marginTop: 2 }}>
            Финансовый контроль
          </div>
        </div>

        {title && (
          <h1 style={{ fontSize: 15.5, fontWeight: 600, margin: '0 0 16px' }}>{title}</h1>
        )}

        {children ?? <Outlet />}
      </main>
    </div>
  );
}
